import { fetchPixabayVideo } from "../../api/pixabay";
import { uploadHandler } from "../../api/upload";
import {
  featchBgVideos,
  featchUserBgVideos,
  removeUserVideo,
} from "../../api/video";
import { PIXABAY_COLLECTIONS } from "../../constants/imageServices";
import {
  setIdle,
  setImageLoading,
  setLoading,
} from "../../store/common/appStateSlice";
import { setBgVideo, setCollections } from "../../store/video/videoSlice";
import { wrapPixabayVideos } from "../../utils";
import { getFromLocal } from "../../utils/localStorage";

export const loadBgVideoFromTemplate = (title) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const data = await featchBgVideos();
    const collections = [
      ...new Set((data?.data || []).filter((d) => d.tag).map((d) => d.tag)),
    ].map((d) => ({ title: d, id: d }));

    dispatch(setCollections(collections));
    const filterVideos = (data?.data || []).filter(
      (d) =>
        (d.tag || "").toLowerCase() ===
        (title || collections[0].title).toLowerCase()
    );
    dispatch(setBgVideo(filterVideos));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading unsplash collections", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};

export const loadBgVideoOfUser = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const data = await featchUserBgVideos(getFromLocal("userId"));

    dispatch(setBgVideo(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading unsplash collections", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};

export const loadPixabayVideoCollections =
  (collectionId) => async (dispatch) => {
    try {
      dispatch(setLoading());
      dispatch(setCollections(PIXABAY_COLLECTIONS));

      dispatch(setIdle());
    } catch (error) {
      console.error("Error loading Pixabay collections", error);
      // Handle the error state appropriately, e.g., setting an error state in your store
      dispatch(setIdle());
    }
  };

export const loadPexelsVideo = (collectionId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const data = wrapPixabayVideos(
      await fetchPixabayVideo(collectionId || PIXABAY_COLLECTIONS[0].id)
    );

    dispatch(setBgVideo(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading Pexels collections", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};

export const handleVideoUpload = (fileHandle) => async (dispatch, getState) => {
  const { bgVideo } = getState().video;
  dispatch(setLoading());
  const video = await uploadHandler(
    getFromLocal("userId"),
    fileHandle,
    "video"
  );
  dispatch(setBgVideo([...bgVideo, video]));
  dispatch(setIdle());
};

export const removeVideo = (id) => async (dispatch, getState) => {
  try {
    dispatch(setImageLoading());
    const userId = getFromLocal("userId");
    await removeUserVideo(userId, id);
    const videos = getState().video.bgVideo;
    dispatch(setBgVideo(videos.filter((i) => i.id !== id)));
    dispatch(setIdle());
  } catch (error) {
    console.log(error);
    dispatch(setIdle());
  }
};
